<template>
  <div class="container">
    <!-- 头部区域 -->
    <div class="header">
      <!-- 背景图片铺好后，还有顶部tab栏和申请试用按钮 -->
      <div class="tab">
        <!-- 空一个江苏城歌的位置 -->
        <div class="name">
          <!-- logo -->
          <div class="logo"></div>
          <!-- name -->
          <div class="real-name">
            <img src="../assets/img/home/chengge.png" alt="" />
          </div>
        </div>
        <!-- 标题栏 -->
        <div class="title">
          <!-- for循环tabNameList -->
          <div
            class="title-item"
            v-for="(item, index) in tabNameList"
            :key="index"
          >
            <div class="title-name" @click="goDetail(item.path)">
              {{ item.name }}
            </div>
            <!-- 是否右边斜杠 -->
            <div v-if="item.slash" class="slash">/</div>
          </div>
        </div>
        <!-- 右侧服务热线 -->
        <!-- <div class="tel">
          <div class="phone">
            <img src="../assets/img/home/phone.png" alt="" />
          </div>
          <div class="tel-num">
            <div style="letter-spacing: 16px;margin-left:5px;">服务热线</div>
            <div>
              {{ mobile }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 正文 -->
    <div class="content">
      <div class="item" v-for="(item, index) in caseList" :key="index">
        <!-- 为了居中对齐，再嵌套一个版心 -->
        <div class="w">
          <!-- 左边图片 -->
          <div class="img">
            <img :src="item.img" alt="" />
          </div>
          <!-- 右边内容 -->
          <div class="detail">
            <!-- 标题 -->
            <div class="detail-title">
              {{ item.name }}
            </div>
            <div class="intro">
              <div class="intro-tit">项目简介</div>
              <div class="intro-content">{{ item.detail }}</div>
            </div>
            <!-- 咨询按钮 -->
            <div class="forward" @click="referApply">
              预约咨询
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 预约咨询弹框 -->
    <Refer :data="isOpenRefer" @refer="refer"></Refer>
  </div>
</template>

<script>
import Refer from './refer.vue'
export default {
  components: {
    Refer
  },
  data() {
    return {
      // 标题栏
      tabNameList: [
        {
          name: '首页',
          path: '/',
          slash: true
        },
        {
          name: '关于我们',
          path: '/about',
          slash: true
        },
        {
          name: '智慧农贸',
          path: '/market',
          slash: true
        },
        {
          name: 'AI识别',
          path: '/AI',
          slash: true
        },
        {
          name: '成功案例',
          path: '/case',
          slash: true
        },
        {
          name: '联系我们',
          path: '/contact',
          slash: false
        }
      ],
      // 案例列表
      caseList: [
        {
          name: '智慧农贸市场系统开发',
          img: require('../assets/img/case/market.png'),
          detail:
            '负责常州武青路智慧农贸市场的开发服务，该服务中包括了小程序开发、管理后台开发、市场监管平台开发、数据可视化大屏设计、商场导购屏开发设计的一站式服务，公司秉承用心做产品的概念，6个月完成了一整套开发任务，成功与农贸市场交接。'
        },
        {
          name: '电子称AI识别',
          img: require('../assets/img/case/cheng.png'),
          detail:
            '人工智能识别采用了卷积神经网络技术，能够自动识别瓜果蔬菜的品类。'
        },
        {
          name: '高考志愿小程序开发',
          img: require('../assets/img/case/zhiyuan.png'),
          detail:
            '一款用于高考填报志愿的软件，通过大数据算法，自动匹配考生的省份、分数、排名，给予其理想的学校和专业数据。'
        },
        {
          name: '国启乐购APP开发',
          img: require('../assets/img/case/guoqi.jpg'),
          detail:
            '致力于为消费者提供优质的产品和更好的购物体验，提供非遗礼品包、城市礼品包、牡丹文化礼品包，让消费者畅享更为便捷的网购服务。'
        }
      ],
      mobile: this.GLOBAL.mobile,
      // 预约咨询
      isOpenRefer: false
    }
  },
  created() {},
  methods: {
    // 跳转到其他页面
    goDetail(path) {
      this.$router.push(path)
    },
    // 预约咨询
    referApply() {
      this.isOpenRefer = true
    },
    refer(data) {
      this.isOpenRefer = data
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  background-color: #f5f5f5;
}
// 头部区域
.header {
  height: 552px;
  width: 100%;
  background-image: url(../assets/img/case/banner.png);
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  color: #fff;
  font-size: 22px;
  .tab {
    display: flex;
    padding: 40px 50px 0 50px;
    margin: 0 auto;
    width: 1300px;
    .name {
      width: 255px;
      .real-name {
        img {
          margin-top: -10px;
        }
      }
    }
    .title {
      width: 960px;
      display: flex;
      height: 40px;
      line-height: 40px;
      .title-item {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        width: 160px;
        .title-name {
          width: 120px;
          text-align: center;
          margin-left: 20px;
        }
        .title-name:hover {
          font-size: 26px;
        }

        .slash {
          color: #d5d5d5;
        }
      }
    }
    .tel {
      width: 300px;
      display: flex;
      .phone {
        line-height: 60px;
        img {
          width: 37px;
          height: 37px;
        }
      }
      .tel-num {
        width: 160px;
        margin: -10px 0 0 20px;
      }
    }
  }
  .applybtn {
    position: relative;
    top: 550px;
    margin: 0 auto;
    border: 1px solid #fff;
    text-align: center;
    height: 80px;
    line-height: 80px;
    width: 322px;
    border-radius: 40px;
    font-weight: 500;
    letter-spacing: 5px;
    cursor: default;
    font-size: 28px;
  }
  .applybtn:hover {
    font-size: 30px;
  }
}
// 正文
.content {
  .item {
    height: 511px;
    background-color: #fff;
    margin-bottom: 80px;
    .w {
      width: 1300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        height: 511px;
        line-height: 511px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 475px;
          height: 407px;
        }
      }
      .detail {
        height: 311px;
        margin-left: 53px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .detail-title {
          color: #2c65ce;
          font-size: 36px;
          font-weight: 700;
        }
        .intro {
          .intro-tit {
            color: #333;
            font-size: 22px;
            font-weight: 500;
          }
          .intro-content {
            margin-top: 20px;
            color: #999;
            font-size: 18px;
          }
        }
        .forward {
          margin: 0 auto;
          width: 180px;
          height: 40px;
          line-height: 40px;
          background-color: orange;
          color: #fff;
          text-align: center;
          border-radius: 40px;
          cursor: pointer;
        }
      }
    }
  }
  .item:nth-child(2n) {
    .w {
      flex-direction: row-reverse;
    }
  }
}
</style>
